<template>
  <vs-card class="content_mb_0 mb-0  h-full">
    <form data-vv-scope="add">
      <vs-row>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="12" class="p-2">
          <div class="user_profile_img_holder">
            <img :src="teacherPersonalDetails.basic_details.picture" alt="dp" />
          </div>
          <div class="pl-4">
            <p>
              {{ teacherPersonalDetails.basic_details.first_name }}
              {{ teacherPersonalDetails.basic_details.last_name }}
            </p>
            <p>
              {{
                teacherPersonalDetails.basic_details.email
                  ? teacherPersonalDetails.basic_details.email.email
                  : "Not Available"
              }}
            </p>
            <div class="flex flex-wrap mt-4">
              <vs-button
                style="width: 80px"
                class="m-1"
                @click="editData = true"
                >Edit</vs-button
              >
            </div>
          </div>
        </vs-col>
        <vs-col vs-lg="7" vs-sm="12" class="p-2">
          <vs-row class="profile_row_details">
            <vs-col vs-w="6" class="flex items-center p-1">
              <span class="material-icons-outlined">grade</span>
              <label>Username</label>
            </vs-col>
            <vs-col vs-w="6" class="p-1">
              <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">
                {{
                  teacherPersonalDetails.basic_details.email
                    ? teacherPersonalDetails.basic_details.email.email
                    : "Not Available"
                }}
              </p>
              <vs-input
                v-else
                class="w-full"
                disabled
                v-model="teacherPersonalDetails.basic_details.email.email"
              ></vs-input>
            </vs-col>
            <!-- <vs-col vs-w="6" class="flex items-center p-1">
              <span class="material-icons-outlined">grade</span>
              <label>Role</label>
            </vs-col>
            <vs-col vs-w="6" class="p-1">
              <p v-if="!editData">
                {{
                  teacherPersonalDetails.basic_details.roles.length > 0
                    ? teacherPersonalDetails.basic_details.roles[0].role_name
                    : "Not Available"
                }}
              </p>
              <v-select
                v-else
                v-model="
                  teacherPersonalDetails.basic_details.roles[0].user_role_id
                "
                :reduce="(option) => option.user_role_id"
                label="role_name"
                :options="roleList"
                style="width: 100%"
              />
            </vs-col> -->
            <vs-col vs-w="6" class="flex items-center p-1">
              <span class="material-icons-outlined">call</span>
              <label>Phone Number</label>
            </vs-col>
            <vs-col vs-w="6" class="p-1">
              <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">
                {{
                  teacherPersonalDetails.basic_details.phone
                    ? teacherPersonalDetails.basic_details.phone.phone
                    : "Not Available"
                }}
              </p>
              <vs-input
                v-else
                class="w-full"
                v-model="teacherPersonalDetails.basic_details.phone.phone"
              ></vs-input>
            </vs-col>
            <vs-col vs-w="12" class="text-right p-1" v-if="editData">
              <span
                style="font-size: 24px; color: green"
                class="material-icons-outlined cursor-pointer mr-0"
                @click="updateBasicDetail"
                >done</span
              >
              <span
                style="font-size: 24px; color: red"
                class="material-icons-outlined cursor-pointer mr-0"
                @click="editData = false"
                >clear</span
              >
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </form>
  </vs-card>
</template>
<script>
import { delete_users, role_list, update_user } from '@/api/user'
import vSelect from 'vue-select'

export default {
  props: {
    teacherPersonalDetails: {
      default: {}
    }
  },
  mounted () {
    const data = this.fetchRoleList('custom')
    if (data) {
      this.fetchRoleList('system')
    }
  },
  components: {
    vSelect
  },
  data () {
    return {
      teacher_id: JSON.parse(localStorage.getItem('userInfo')).id,
      editData: false,
      roleList: []
    }
  },
  methods: {
    async fetchRoleList (type) {
      try {
        const paramspayload = {
          type
        }
        console.log(paramspayload)
        const res = await role_list(
          this.$store.getters.customerId,
          paramspayload
        )

        this.roleList = [...this.roleList, ...res.data.data.role_list]
        console.log(this.roleList)
      } catch (error) {
        //
      }
    },
    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are You Sure You want to delete this Staff?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.staff_Delete()
    },
    async staff_Delete () {
      const deleting_id = this.teacher_id
      const payload = {
        deleteField: [deleting_id]
      }
      try {
        await delete_users(payload, localStorage.getItem('customer_id'))

        this.$vs.notify({
          color: 'success',
          title: 'Deleted Staff',
          text: 'Staff deleted successfully'
        })
        this.$router.push({ name: 'Staff' })
      } catch (e) {
        //
      }
    },
    updateBasicDetail () {
      this.$validator.validateAll('add').then((valid) => {
        if (valid) {
          this.updateBasicDetails()
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'All required fields are mandatory',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      })
    },
    async updateBasicDetails () {
      try {
        const object1 = {
          dynamic_fields: {}
        }
        console.log(this.teacherPersonalDetails.basic_details)
        const reqUpload = {
          updateField: {
            phone:this.teacherPersonalDetails.basic_details.phone.phone,
            email:this.teacherPersonalDetails.basic_details.email.email,
            user_roles_id:this.teacherPersonalDetails.basic_details.roles[0].user_role_id
          }
        }
        object1.dynamic_fields = this.dynamicform
        const payload = Object.assign({}, reqUpload, object1)

        const customerId = this.$store.getters.customerId

        const {data} = await update_user(this.teacher_id, payload, customerId)

        this.editData = false
        this.showSuccessMessage(
          'Success',
          'Staff updated successfully',
          'success'
        )
        this.$emit('setAfterUpdate', data)
      } catch (e) {
        //
      }
    }
  }
}
</script>